import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // Correct credentials (Replace with your actual authentication logic)
    const correctUsername = "Admin";
    const correctPassword = "Inndus";

    // Handle login
    const handleLogin = () => {
        if (username === correctUsername && password === correctPassword) {
            navigate("/collection/22"); // Redirect if login is correct
        } else {
            setError("Invalid username or password");
        }
    };
const loginImage= ()=>{
    navigate("/collection/22"); // Redirect if login is correct
}
    return (
        <div className="footer-main">
            {/* Floating Image Button */}
            <div className="footer-img">
                <img
                    src={`${baseURL}/images/Browse-our-design.svg`}
                    alt="Login"
                    className="footer-img"
                    onClick={loginImage}
                />
            </div>

            {/* Login Modal */}
            {isModalOpen && (
                <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{textAlign:'left'}}>
                        <button className="close-btn" onClick={() => setIsModalOpen(false)}>×</button>
                        <label style={{color:'black'}}>User Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                         <label style={{color:'black'}}>Password:</label>
                        <input
                            type="password"
                            placeholder="Password"
                             className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {error && <p className="error">{error}</p>}
                        <br />
                        <button className="login-btn btn-sm-primary" onClick={handleLogin}>Login</button>
                    </div>
                </div>
            )}

            {/* Footer Content */}
            <div className="container">
                <div className="row footer-row">
                    <div className="col-sm-6 footer">
                        <p>PRODUCTS</p>
                        <ul>
                            <li><Link className="anchor-footer" to="/design/1">Business Stationery</Link></li>
                            <li><Link className="anchor-footer" to="/design/2">Marketing Collateral</Link></li>
                            <li><Link className="anchor-footer" to="/design/3">Gifts</Link></li>
                            <li><Link className="anchor-footer" to="/design/4">Decor</Link></li>
                        </ul>
                    </div>
                    <div className="col-sm-6 footer">
                        <p>CONTACT</p>
                        <ul>
                            <li>B-14, Durian Estate</li>
                            <li>Goregaon Mulund Link Road</li>
                            <li>Goregaon East, Mumbai 400063</li>
                            <li>022-40968900 | print@inndus.com</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Modal Styling */}
            <style>{`
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }
                .modal-content {
                    background: white;
                    padding: 20px;
                    border-radius: 8px;
                    text-align: center;
                    position: relative;
                    width: 300px;
                }
                .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
    background: red;
    color: white;
    font-size: 10px;
    cursor: pointer;
    /* padding: 5px 10px; */
    border-radius: 50%;
}
                input {
                    width: 90%;
                    padding: 10px;
                    margin: 10px 0;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                }
                .login-btn {
                    background-color: blue;
                    color: white;
                    border: none;
                    padding: 10px;
                    cursor: pointer;
                    width: 100%;
                }
                .error {
                    color: red;
                    font-size: 14px;
                }
            `}</style>
        </div>
    );
};

export default Footer;





// import React from "react";
// import { Link } from "react-router-dom";


// const Footer = () => {
//     return (
//         <div className="footer-main">
//             <div>
//                 <Link to='/test' >
//             <img width="40" height="40" src="https://img.icons8.com/external-thin-kawalan-studio/24/external-image-search-multimedia-thin-kawalan-studio.png" alt="external-image-search-multimedia-thin-kawalan-studio" style={{ position:'fixed', right:'2%', bottom:'29%'}} />
//     </Link>

//             </div>
//         <div className="container">
//             <div className="row footer-row">
//                 {/* <div className="col-sm-3 footer">
//                     <p>Main Menu</p>
//                         <ul>
//                             <li>Home</li>
//                             <li>About US</li>
//                             <li>Contact Us</li>
//                             <li>Products</li>
//                             <li>Services</li>
//                         </ul>
//                 </div>
//                 <div className="col-sm-3 footer">
//                     <p>Services</p>
//                         <ul>
//                             <li>Request a Quote</li>
//                             <li>Upload a File</li>
//                             <li>Designing Services</li>
//                             <li>Terms and Conditions</li>
//                             <li>Privacy Policy</li>
//                         </ul>
//                 </div> */}
//                 <div className="col-sm-6 footer">
//                     <p>PRODUCTS</p>
//                     <ul>
//     <li><Link className="anchor-footer" to="/design/1">Business Stationery</Link></li>
//     <li><Link className="anchor-footer" to="/design/2">Marketing Collateral</Link></li>
//     <li><Link className="anchor-footer" to="/design/3">Gifts</Link></li>
//     <li><Link className="anchor-footer" to="/design/4">Decor</Link></li>
// </ul>

//                 </div>
//                 <div className="col-sm-6 footer">
//                     <p>CONTACT</p>
//                     <ul>
//                      <li>B-14, Durian Estate</li>
//                      <li>Goregaon Mulund Link Road </li>
//                        <li> Goregaon East, Mumbai 400063</li>

                       
//                         <li>  022-40968900 | print@inndus.com</li>
                        
//                     </ul>
//                 </div>
//             </div>
//             </div>
//         </div>
//     )
// }

// export default Footer;


